<template lang="html">
  <section class="navigation-tabs">
    <div class="navigation-tabs-container">
      <router-link
        v-for="(tab, index) in tabs"
        :key="index"
        :to="tab"
        class="route-nav-link"
        :class="selectedTabClass(tab)"
        >{{ tab.text }}</router-link
      >
    </div>
    <div class="bottom-line"></div>
  </section>
</template>

<script lang="js">
  export default  {
    name: "navigation-tabs",
    props: {
      tabs: {
        type: Array,
        default: function() {
          return [];
        }
      }
    },
    methods: {
      selectedTabClass(nav) {
        return this.isSelectedTab(nav)? "selected-tab" : "unselected-tab";
      },
      isSelectedTab(nav) {
        return this.$route.name === nav.name || this.$route.path === nav.path
      }
    }
  }
</script>

<style scoped lang="scss">
  .navigation-tabs {
    position: relative;
    box-sizing: border-box;
    height: 100%;

    .navigation-tabs-container {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      height: 100%;
      width: 100%;
    }

    .bottom-line {
      border-bottom: 1px solid var(--LIGHT_GRAY);
      width: 100%;
      height: 1px;
      position: relative;
      bottom: 1px;
    }

    .route-nav-link {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-decoration: none;
      padding: 0 1rem;
      height: 100%;
      color: inherit;
      display: flex;
      align-items: center;
      border-bottom: 3px solid transparent;
    }

    .route-nav-link:hover {
      text-decoration: none;
      border-bottom: 3px solid var(--BTN_TEXT_BLUE);
    }

    .selected-tab {
      cursor: inherit;
      border-bottom: 3px solid var(--BTN_TEXT_BLUE);
      font-weight: 700;
    }

    .unselected-tab {
      color: var(--TEXT_DISCLAIMER_GREY);
    }
  }
</style>
